// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__2uLS5","errors":"Errors_errors__V-zaR"};